import PropTypes from "prop-types";
import React from "react";

import { classNames } from "@swa-ui/string";

import { HtmlValue } from "../HtmlValue";
import styles from "./TextBlock.module.scss";

/**
 * TextBlock renders content as a text block.
 */

export const TextBlock = (props) => {
  const { additionalProps = {}, text } = props;
  const { light } = additionalProps;

  return (
    <>
      {text.map((textItem, index) => (
        <div
          key={index}
          style={{
            color: textItem.color,
            fontSize: textItem.fontSize,
          }}
        >
          {Array.isArray(textItem?.value) ? (
            textItem?.value.map((node, itemIndex) =>
              typeof node === "string" ? (
                <HtmlValue
                  key={itemIndex}
                  htmlValue={node}
                  className={classNames({ [styles.light]: light })}
                />
              ) : (
                React.cloneElement(node, {
                  className: classNames({ [styles.light]: light }),
                  key: itemIndex,
                })
              )
            )
          ) : (
            <HtmlValue
              className={classNames({ [styles.light]: light })}
              htmlValue={textItem.value}
            />
          )}
        </div>
      ))}
    </>
  );
};

TextBlock.displayName = "TextBlock";
TextBlock.propTypes = {
  /**
   * Additional props that can include configuration for styling, such as `light` to indicate
   * whether the app is using a dark Header background.
   */
  additionalProps: PropTypes.object,
  /** Content to be rendered. */
  text: PropTypes.arrayOf(
    PropTypes.shape({
      color: PropTypes.string,
      fontSize: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.node)]),
    })
  ),
};
